module.exports = __webpack_public_path__ + "img/washing-svgrepo-com.4de0bbeb.svg";